import { translate } from "../translations/translate";
export const TIMESHEET_ACTION_STATES = {
  SUBMITTED: "Submitted",
  DRAFT: "Draft",
  APPROVED: "Approved",
  REJECTED: "Rejected",
};
export const STATUS_OPTIONS = [
  {
    label: "Active",
    value: "Active",
  },
  {
    label: "Inactive",
    value: "Inactive",
  },
];
export const APPROVAL_ACTIONS = [
  {
    label: "Approve",
    value: TIMESHEET_ACTION_STATES.APPROVED,
  },
  {
    label: "Reject",
    value: TIMESHEET_ACTION_STATES.REJECTED,
  },
];
export const ACCOUNT_TYPE_MAPPINGS = {
  ADMIN: "Admin",
  APPROVER: "Approver",
  EMPLOYEE: "Employee",
};
export const RESOURCE_TYPE_OPTIONS = [
  {
    label: "Admin",
    value: "Admin",
  },
  {
    label: "Approver",
    value: "Approver",
  },
  {
    label: "Employee",
    value: "Employee",
  },
];

export const HEADER_ACTION_OPTIONS = [
  {
    label: "Profile",
    key: "profile",
  },
  {
    label: "Help",
    key: "help",
  },
  {
    label: "Logout",
    key: "logout",
  },
];

export const DOWNLOAD_OPTIONS = [
  {
    label: translate("labels.downloadToExcel"),
    key: "excel",
  },
  {
    label: translate("labels.downloadToPdf"),
    key: "pdf",
  },
];

export const EMPLOYMENT_TYPE_OPTIONS = [
  {
    label: "W2",
    value: "W2",
  },
  {
    label: "C2C",
    value: "C2C",
  },
  {
    label: "1099",
    value: "1099",
  },
];

export const PAYMENT_TYPE_OPTIONS = [
  { label: "NET30", value: "NET30" },
  { label: "NET35", value: "NET35" },
  { label: "NET45", value: "NET45" },
  { label: "NET60", value: "NET60" },
  { label: "NET90", value: "NET90" },
  { label: "NET120", value: "NET120" },
  { label: "Others", value: "OTHERS" },
];

export const INVOICE_FREQUENCY_OPTIONS = [
  { label: "Weekly", value: "Weekly" },
  { label: "Bi-Weekly", value: "Bi_weekly" },
  { label: "Monthly", value: "Monthly" },
  { label: "Others", value: "Others" },
];

export const PROJECT_TASKS_OPTIONS = [
  { label: "Account Management", value: "account_management" },
  { label: "Architecture Design", value: "architecture_design" },
  { label: "Business Analysis", value: "business_analysis" },
  { label: "Development", value: "development" },
  { label: "Legal Services", value: "legal_services" },
  { label: "Planning", value: "planning" },
  { label: "Project Management", value: "project_management" },
  { label: "Sales", value: "sales" },
  { label: "Support", value: "support" },
  { label: "Testing", value: "testing" },
  { label: "Training", value: "training" },
  { label: "Travel", value: "travel" },
];
export const BILLABLE_OPTIONS = [
  {
    label: "Billable",
    value: "Billable",
  },
  {
    label: "Non-Billable",
    value: "Non-Billable",
  },
];
export const PAY_CODE_OPTIONS = [
  {
    label: "Regular Time",
    value: "RegularTime",
  },
  {
    label: "Over Time",
    value: "OverTime",
  },
];

export const USER_MANAGEMENT_ACTIONS = [
  {
    label: "Mark User(s) as Active",
    key: "Active",
  },
  {
    label: "Mark User(s) as Inactive",
    key: "Inactive",
  },
  {
    label: "Delete User(s)",
    key: "Delete",
  },
];

export const TIMESHEET_STATES = ["draft", "submitted", "approved", "rejected"];
export const PAGE_SIZES = [10, 25, 50, 100];
export const DEFAULT_PAGE_SIZE = 25;
export const TOAST_TIMER = 10000;
export const MAX_FILE_SIZE_IN_MB = 10;
export const DATE_TIME_FORMAT = {
  DISPLAY: "MMM DD, YYYY",
  PICKER: "MMM DD, YYYY",
};
